import React from 'react';
import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { getVideoLink } from 'helpers/getVideoLink';

import * as S from '../styled';

const SecondStep = () => {
    const { t } = useTranslation();

    return (
        <S.Step>
            <S.StepContent>
                <S.StepColumn>
                    <S.StepNumber $mb={24}>
                        <Text type="large-text" center bold>
                            2
                        </Text>
                    </S.StepNumber>
                    <Text mb={16} type="large-text" bold>
                        {t('main.logInToAccount')}
                    </Text>
                    <S.SubText>{t('main.logInToApp')}</S.SubText>
                </S.StepColumn>

                <S.StepColumn>
                    <S.Video maxWidth={190} alt="video" src={getVideoLink()} />
                </S.StepColumn>
            </S.StepContent>
        </S.Step>
    );
};

export default SecondStep;
